var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsSalesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 63.3333H66.6667C68.5076 63.3333 70 64.8257 70 66.6667C70 68.5076 68.5076 70 66.6667 70H13.3333C11.4924 70 10 68.5076 10 66.6667V13.3333C10 11.4924 11.4924 10 13.3333 10C15.1743 10 16.6667 11.4924 16.6667 13.3333V63.3333Z",
    fill: "#003F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M29.0984 48.9465C27.8393 50.2895 25.7298 50.3576 24.3868 49.0985C23.0438 47.8394 22.9757 45.7299 24.2348 44.3869L36.7348 31.0535C37.9525 29.7547 39.976 29.642 41.3303 30.7977L51.1961 39.2165L64.0503 22.9345C65.1911 21.4896 67.2872 21.243 68.7321 22.3837C70.177 23.5245 70.4236 25.6206 69.2829 27.0655L54.2829 46.0655C53.1113 47.5495 50.9412 47.763 49.5029 46.5356L39.4227 37.9339L29.0984 48.9465Z",
    fill: "#003F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsSalesIcon);
export default __webpack_public_path__ + "static/media/reports-sales-icon.42c76ff9f3d414648902a3c4e87f9b9b.svg";
export { ForwardRef as ReactComponent };